/**
 * This file is auto-generated during scaffold, you should not edit manually.
 */

import { appProvider } from "./appProvider";
import { campaignProvider } from "./campaignProvider";
import { canvasProvider } from "./canvasProvider";
import { canvasStepProvider } from "./canvasStepProvider";
import { cohortProvider } from "./cohortProvider";
import { csvImportProvider } from "./csvImportProvider";
import { customAttributeProvider } from "./customAttributeProvider";
import { customEventProvider } from "./customEventProvider";
import { developerProvider } from "./developerProvider";
import { purchaseProvider } from "./purchaseProvider";
import { segmentCohortProvider } from "./segmentCohortProvider";
import { sparseSegmentProvider } from "./sparseSegmentProvider";
import { tagProvider } from "./tagProvider";
import { territoryProvider } from "./territoryProvider";

export const providers = {
  app: appProvider,
  campaign: campaignProvider,
  canvas: canvasProvider,
  canvas_step: canvasStepProvider,
  cohort: cohortProvider,
  csv_import: csvImportProvider,
  custom_attribute: customAttributeProvider,
  custom_event: customEventProvider,
  developer: developerProvider,
  purchase: purchaseProvider,
  segment_cohort: segmentCohortProvider,
  sparse_segment: sparseSegmentProvider,
  tag: tagProvider,
  territory: territoryProvider,
} as const;
